(function(){
  const reduceMotion=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click',function(event){
    const summary=event.target.closest('.vxe-section .vxe-trigger');
    if(!summary)return;
    const details=summary.closest('.vxe-details');
    const panel=details?.querySelector('.vxe-reveal');
    if(!details || !panel || reduceMotion() || !panel.animate)return;
    event.preventDefault();
    if(details.dataset.vxeAnimating==='true')return;
    details.dataset.vxeAnimating='true';
    const closing=details.open;
    let animation;
    if(closing){
      const from=panel.getBoundingClientRect().height;
      animation=panel.animate([
        {height:from+'px',opacity:1},
        {height:'0px',opacity:0}
      ],{duration:310,easing:'cubic-bezier(.55,0,.85,.45)'});
    }else{
      panel.style.height='0px';
      panel.style.opacity='0';
      details.open=true;
      const to=panel.scrollHeight;
      animation=panel.animate([
        {height:'0px',opacity:0},
        {height:to+'px',opacity:1}
      ],{duration:400,easing:'cubic-bezier(.22,1,.36,1)'});
    }
    const finish=()=>{
      if(closing)details.open=false;
      panel.style.height='';
      panel.style.opacity='';
      delete details.dataset.vxeAnimating;
    };
    animation.onfinish=finish;
    animation.oncancel=finish;
  });
})();